var magicStyles = [".prefix[data-v-58f69684]{flex-basis:calc(((100% - 8px) * .375) + -2px);flex-grow:0}.number[data-v-58f69684]{flex-basis:calc(((100% - 8px) * .625) + 2px);flex-grow:0}"];

export default magicStyles;
